module.exports = __webpack_public_path__ + "static/img/ic_termination.c066be56.svg";